module.exports = __webpack_public_path__ + "img/img_7.5d1422e1.png";